import React from "react";
import MobileTitleEquipmentData from "./TitleEquiomentData";

function MobileEquipmentPro({ Data, getData, projectList, projectId ,Unit}) {
  

  return (
    <div className=" w-full  h-[70vh] overflow-y-auto">
      {Data &&
        Data.map((item, idx) => {
          return (
            <MobileTitleEquipmentData rowData={item} key={idx} getData={getData} projectList={projectList} projectId={projectId}  Unit={Unit} />
          );
        })}
    </div>
  );
}

export default MobileEquipmentPro;
